import { graphql } from 'gatsby';
import { Error404 } from "../../../../src/components/empty-state/Error404";
import * as React from 'react';
export default {
  graphql,
  Error404,
  React
};